import { createEvent } from 'effector';
import { DEFAULT_LIMIT_ROWS } from '../../consts';
import { TStateStoreReducer } from '../../models';

type TPayload = {
  newPage: number;
  totalRows?: number;
};
type TReducer = TStateStoreReducer<TPayload>;

export const changePageEvent = createEvent<TPayload>();
export const changePagingReducer: TReducer = (state, { newPage, totalRows }) => {
  const currLimit = state.paging?.limit || DEFAULT_LIMIT_ROWS;
  const newOffset = Math.max(newPage - 1, 0) * currLimit;

  if (newOffset < 0 || !totalRows || newOffset > totalRows) {
    return state;
  }

  return {
    ...state,
    paging: {
      offset: newOffset,
      limit: state.paging.limit,
    },
  };
};
